import { fade, hexToRgb } from '@material-ui/core/styles'

export default function hexToRgba(hex: string, opacity = 1) {
  return fade(hexToRgb(hex), opacity)
}
